import { put, take } from 'redux-saga/effects'
import * as endpoints from '../constants/RabbitQueueEndpoints';
import * as actions from '../actions/chatActions';


export const endpoint = endpoints.QUEUE_CHAT_MESSAGES;

export const handler = (emit, message) =>
  emit(actions.messageReceived(JSON.parse(message.body)));

export function* read(queue) {
  while (true) {
    const action = yield take(queue);
    yield put(action);
  }
}
